// extracted by mini-css-extract-plugin
export default {"root":"gp_6BM","mobile":"CHzvbh","feed":"yorD6r","title":"FwqIRl"};